export default "__VITE_ASSET__B3il2Em9__"